import { CommandData } from "../../command";
import { GxmlCommand } from "./gxml-command";
export class InsertNodeCommand extends GxmlCommand {
    constructor(parent, child, position) {
        super();
        this._parent = parent;
        this._child = child;
        this._position = position;
    }
    get id() {
        return InsertNodeCommandData.ID;
    }
    get parent() {
        return this._parent;
    }
    get child() {
        return this._child;
    }
    get position() {
        return this._position;
    }
    get changeRoot() {
        return this._parent;
    }
    do() {
        this._parent.insertNode(this._child, this._position);
        return true;
    }
    undo() {
        return this._parent.removeNode(this._child);
    }
    getData() {
        let isNew = this._child.isNew;
        return {
            id: this.id,
            parentId: this._parent.id,
            child: isNew ? this._child.toData(false) : this._child.id, // do not include children if the node is new since children nodes will have their own command
            position: this._position
        };
    }
}
export var InsertNodeCommandData;
(function (InsertNodeCommandData) {
    InsertNodeCommandData.ID = 'InsertNode';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === InsertNodeCommandData.ID
            && 'parentId' in arg
            && 'child' in arg
            && 'position' in arg;
    }
    InsertNodeCommandData.is = is;
})(InsertNodeCommandData || (InsertNodeCommandData = {}));
//# sourceMappingURL=insert-node-command.js.map